import { motion, animate } from "framer-motion";
import { useEffect, useRef } from "react";

import { ColoredNetworkIconMap, NetworkIconMap } from "@/constants/map";
import { useStore } from "@/hooks/store";
import { useHasHorizontalScroll } from "@/hooks/useHasHorizontalScroll";
import { Network } from "@/interfaces/network";

import styles from "./styles";

export const Networks = () => {
  const { networks, currentNetwork, switchNetwork } = useStore((state) => ({
    networks: Object.values(state.user.networksData),
    currentNetwork: state.network,
    switchNetwork: state.switchNetwork,
  }));
  const handler = async (network: Network) => {
    if (network === currentNetwork) return;
    switchNetwork(network);
  };
  const ref = useRef<HTMLDivElement>(null);
  const lastItemRef = useRef<HTMLDivElement>(null);
  const hasHorizontalScroll = useHasHorizontalScroll(ref);

  useEffect(() => {
    if (lastItemRef.current?.scrollIntoView && ref.current && currentNetwork === Network.ETHEREUM) {
      animateScroll(ref.current, 800);
    }
  }, []);

  const animateScroll = (element: HTMLDivElement, to: number) => {
    const controls = animate(element.scrollLeft, to, {
      type: "spring",
      stiffness: 100,
      damping: 20,
      onUpdate(value) {
        element.scrollLeft = value;
      },
    });

    return () => controls.stop();
  };

  return (
    <styles.Container ref={ref} className="no-scrollbar" $hasHorizontalScroll={hasHorizontalScroll}>
      {networks.map(({ network, score, availableAction }) => (
        <styles.Network
          ref={network === Network.ETHEREUM ? lastItemRef : null}
          key={network}
          $isActive={currentNetwork === network}
          onClick={() => handler(network)}
        >
          {availableAction && <styles.Dot />}
          {currentNetwork === network ? ColoredNetworkIconMap[network] : NetworkIconMap[network]}
          <styles.Text>
            <motion.div
              initial={{ opacity: 1, y: 0 }}
              animate={{
                y: currentNetwork !== network ? 0 : "65%",
                transition: { duration: 0.2 },
              }}
            >
              {network}
            </motion.div>
            {currentNetwork !== network && (
              <styles.ScoreAmount
                initial={{ opacity: 1, y: "-50%" }}
                animate={{
                  y: 0,
                  transition: { duration: 0.2 },
                }}
              >
                <p>{score?.value || "-"}</p>
                <p>/100</p>
              </styles.ScoreAmount>
            )}
          </styles.Text>
        </styles.Network>
      ))}
    </styles.Container>
  );
};
